import { Chip } from '@mui/material'
import DeleteConfirmationModal from 'commonComponents/DeleteConirmationModel';
import { capitalizeFirstLetter } from 'commonComponents/FirstLetterCaptial'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteOilById } from '../redux/dispatcher';


// Single Row Data Reperesent Component
function RowData({ itemInfo, handleEdit, handleDelete, handleView, currentPage, rowsPerPage, selectedOil }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [itemId, setItemId] = useState(null);

    const dispatch = useDispatch()

    const {data} = useSelector((state)=>state.authReducer);
    const {isLoading} = useSelector((state)=>state.oilListReducer);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleDeleteClick = (id) => {
        setItemId(id); // Set the id to be deleted
        toggleModal(); // Open the modal
      };

    const handleDeleteConfirm = () => {
        const payload = {
            id:itemInfo?.oil_id,
            currentPage,
            rowsPerPage, 
            selectedOil
        }
        dispatch(deleteOilById(payload, toggleModal)) 
      };
    return (
        <>
            <tbody>
                <tr className="align-items-center text-center" >
                    <td>{itemInfo?.serial_number}</td>
                    <td>{itemInfo?.brand_name}</td>
                    <td>{itemInfo?.product_name}</td>
                    <td>{itemInfo?.company_name || "-"}</td>
                    <td>{itemInfo?.price}</td>
                    <td>{itemInfo?.oil_type}</td>
                    <td className={itemInfo?.status === 'active' ? 'text-success' : 'text-danger'}>
                        {
                            itemInfo?.status === 'active' ? <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="success" sx={{ p: 1 }} /> : <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="error" />
                        }

                    </td>

                    <td style={{ padding: '0px' }}>
                        {/* <div className='d-flex d-flex justify-content-around '> */}
                        <div>
                            <i className="fa-solid fa-eye icon_hover" onClick={() => handleView(itemInfo?.oil_id)} style={{ marginRight: '16px' }}></i>
                            <i className="fa-solid fa-pen icon_hover" onClick={() => handleEdit(itemInfo?.oil_id)} ></i>
                            {
                            data?.user?.role === "super_admin" && (
                            <i className="fa-solid fa-trash icon_hover ml-3" onClick={() => handleDeleteClick(itemInfo?.uuid)}></i>
                            )}
                        </div>
                    </td>
                </tr>
            </tbody>
            <DeleteConfirmationModal
            isOpen={modalOpen}
            toggle={toggleModal}
            onConfirm={handleDeleteConfirm}
            itemName={`oil`}
            isLoading={isLoading}
            />
        </>
    )
}

export default RowData
